import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import NotificationList from 'bd-common/src/components/notifications/NotificationsList.vue';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { VButton } from 'ah-common-lib/src/common/components';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { useManagedListing } from 'ah-common-lib/src/listing/useManagedListing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useServices } from 'bd-common/src/services';
import {
  Notification,
  NotificationAlertType,
  PaginatedResponse,
  fileExportNotifications,
  publicNotifications,
} from 'ah-api-gateways';
import ListPagination from '../list/ListPagination.vue';
import LoadingSplash from '../common/LoadingSplash.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginatedNotifications',
  props: {
    type: { default: 'notification' }
  },
  setup(__props: any) {

const props = __props as { type: 'notification' | 'file_export' };



const notificationsStore = useNotificationsStore();

const services = useServices();

const reqManager = useRequestManager().manager;

const alertTypes = [NotificationAlertType.REGULAR, NotificationAlertType.URGENT];

const notificationTypes = computed(() =>
  props.type === 'notification' ? publicNotifications : fileExportNotifications
);

const listing = useManagedListing({
  reqManager,
  fields: ref([]),
  refs: {
    paginationQueryParam: ref('pageData'),
  },
  loadDataRequest(query) {
    return services.notification.listNotifications({
      ...query,
      sort: 'createdAt',
      sortDirection: 'DESC',
      pageSize: 10,
      alertType: alertTypes,
      type: notificationTypes.value,
    });
  },
});

const isNotificationEmpty = computed(
  () =>
    (props.type === 'notification' ? notificationsStore.notifications : notificationsStore.fileExportNotifications)
      .length === 0
);

const unreadCount = computed(() =>
  props.type === 'notification' ? notificationsStore.unreadCount : notificationsStore.fileExportUnreadCount
);

const isAllRead = computed(() => unreadCount.value === 0);

const tableData = computed(() => ({ ...listing.refs.tableData.value, ...listing.refs.sortAndPageParams.value }));

const notifications = computed(() => tableData.value?.list || []);

const loadingData = computed(() => listing.bindings.dataLoadState === 'pending');

const markAllAsRead = () => {
  notificationsStore.markAllAsRead(props.type === 'notification' ? 'notifications' : 'fileExports').then(() => {
    // Casting tableData.value to PaginatedResponse<Notification> as we can trust it isn't a Partial within this context
    const data = listing.refs.tableData.value as any as PaginatedResponse<Notification>;
    if (data) {
      listing.setData({
        ...data,
        list: (data.list || [])?.map((i) => ({
          ...i,
          read: true,
        })),
      });
    }
  });
};

const title = computed(() => (props.type === 'notification' ? 'All Notifications' : 'All Downloads'));

function setPage(page: number) {
  listing.refs.sortAndPageParams.value = { ...listing.refs.sortAndPageParams.value, pageNumber: page };
}

function onMarkedAsRead(markedRead: Notification) {
  const notification = notifications.value.find((n) => n.id === markedRead.id);
  if (notification) {
    notification.read = true;
  }
}

listing.loadData();

return { __sfc: true,props, notificationsStore, services, reqManager, alertTypes, notificationTypes, listing, isNotificationEmpty, unreadCount, isAllRead, tableData, notifications, loadingData, markAllAsRead, title, setPage, onMarkedAsRead, NotificationList, VButton, MaterialIcon, ListPagination, LoadingSplash }
}

})